import { HtmlPrint } from "./html.main"

window.PeachPrint = {
    preview: function (options) {
        HtmlPrint.preview(options)
    },
}